import './bootstrap'
import { useGlobalStore } from '@stores/global'
import { useAuthStore } from '@stores/auth'
import { useEventStore } from '@stores/event'
import { createApp } from 'vue/dist/vue.esm-bundler'
import { createPinia } from 'pinia'
import router from './router'

import clickOutside from '@directives/clickOutside'

const pinia = createPinia()
const app = createApp({}).use(router).use(pinia)
const global = useGlobalStore()
const auth = useAuthStore()
const events = useEventStore()

app.directive('click-outside', clickOutside)

global.setup()
auth.setup()
events.setup()

// Mount
app.mount('#logitech')
